import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { animeList } from "@/mocks/anime";

export default function Hero() {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const featured = animeList.slice(0, 3);

  function handleSearch(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    navigate(query.trim() ? `/biaoqian?q=${encodeURIComponent(query.trim())}` : "/biaoqian");
  }

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-primary-50 via-background-50 to-accent-50 pt-16">
      <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-secondary-200/50 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-16 bottom-0 h-64 w-64 rounded-full bg-accent-200/40 blur-3xl"></div>

      <div className="container-x grid grid-cols-1 items-center gap-10 py-14 md:grid-cols-12 md:py-20">
        <div className="md:col-span-6">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-primary-200 bg-primary-100/70 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-flashlight-line"></i>
            短篇速刷不迷路 · 每日更新
          </span>
          <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
            小水看番
            <span className="mt-2 block text-primary-600">泡面番推荐，下饭番一口气看完</span>
          </h1>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-foreground-600 md:text-lg">
            三分钟短番、日常搞笑短篇、摸鱼短番全收录。按口味分好类，泡面时间、摸鱼间隙、深夜宵夜，都有刚好三分钟的那一部。
          </p>

          <form
            id="home-search-form"
            onSubmit={handleSearch}
            className="mt-7 flex max-w-md items-center overflow-hidden rounded-full border border-background-200 bg-background-50 p-1.5"
          >
            <i className="ri-search-line ml-3 text-foreground-400"></i>
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              type="text"
              placeholder="搜一部短番，例如：泡面时间到了"
              className="h-10 flex-1 bg-transparent px-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
            <button
              type="submit"
              className="btn-pill h-10 bg-primary-500 px-4 text-background-50 hover:bg-primary-600"
            >
              搜番
            </button>
          </form>

          <div className="mt-7 flex flex-wrap items-center gap-6">
            <div>
              <p className="font-heading text-2xl font-black text-foreground-950">120+</p>
              <p className="text-xs text-foreground-500">精选短番</p>
            </div>
            <div className="h-8 w-px bg-background-200"></div>
            <div>
              <p className="font-heading text-2xl font-black text-foreground-950">6大</p>
              <p className="text-xs text-foreground-500">口味分类</p>
            </div>
            <div className="h-8 w-px bg-background-200"></div>
            <div>
              <p className="font-heading text-2xl font-black text-foreground-950">2小时</p>
              <p className="text-xs text-foreground-500">一季追完</p>
            </div>
          </div>
        </div>

        <div className="relative hidden md:col-span-6 md:block">
          <div className="relative mx-auto h-[440px] w-full max-w-md">
            {featured.map((anime, i) => {
              const positions = [
                "absolute left-0 top-6 z-30 w-52 -rotate-6",
                "absolute left-1/2 top-0 z-40 w-52 -translate-x-1/2 rotate-2",
                "absolute right-0 top-24 z-20 w-52 rotate-6",
              ];
              return (
                <div key={anime.id} className={`${positions[i]} overflow-hidden rounded-2xl border-4 border-background-50`}>
                  <img
                    src={anime.image}
                    alt={`${anime.title} 短篇番剧推荐`}
                    className="aspect-[3/4] w-full object-cover object-top"
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}